import { Link } from "react-router-dom";
import {
  FaFacebookF,
  FaInstagram,
  FaChevronUp,
  FaChevronDown,
} from "react-icons/fa";

function Footer() {
  return (
    <div className="row footer d-block">
      <div className="">
        <div className="row form-group row-content m-auto row-font direction-row    ">
          <div
            className={"title-font "}
            style={{
              fontWeight: "bold",
              fontSize: "40px",
              textAlign: "center",
            }}
          >
            WEES ALS EERSTE OP DE HOOGTE VAN HET LAATSTE NIEUWS.
          </div>
          <div className="row form w-100">
            <div className="col-12 col-sm-2 m-auto normal-font">
              <input
                type="nieuwsbrief"
                placeholder="Nieuwsbrief"
                className="footer-inputs"
              />
            </div>
            <div className="col-12 col-sm-2 m-auto">
              <input
                type="name"
                placeholder="Naam*"
                className="footer-inputs"
              />
            </div>
            <div className="col-12 col-sm-3 m-auto">
              <input type="tel" placeholder="Tel*" className="footer-inputs" />
            </div>
            <div className="col-12 col-sm-2 m-auto">
              <input
                type="email"
                placeholder="Email*"
                className="footer-inputs"
              />
            </div>
            <div className="col-12 col-sm-3 m-auto">
              <button className="btn btn-outline-secondary btn-block m-auto footer-btn normal-font">
                ZENDEN
              </button>
            </div>
          </div>
        </div>
      </div>
      <hr className="footer-hr" />
      <div
        className="row row-content m-auto row-font"
        style={{ fontWeight: "bold" }}
      >
        <div className="col-12 col-sm-3">
          <div className="text-center">
            <p>
              <strong>
                The Jerome DeKeyser Property Experience
                <br />
              </strong>
              Verwacht van mij een vriendelijke,efficiente
              <br />
              service, innovatief denken en vooral,weet
              <br />
              dat er geen moeite teveel is, eens u voor
              <br />
              mij heeft gekozen. Daar sta ik&nbsp; garant voor.
            </p>
            <p>
              <strong>Jerome DeKeyser </strong>
            </p>
          </div>
        </div>
        <div className="col-5 col-sm-3 offset-1 offset-sm-0 text-center normal-font">
          <p>
            <Link style={{ color: "inherit" }} to="/">
              WELKOM
            </Link>
          </p>
          <p>
            <Link style={{ color: "inherit" }} to="/search">
              NIEUWS & VIDEO
            </Link>
          </p>
        </div>
        <div className="col-5 col-sm-3 text-center normal-font">
          <p>
            <Link style={{ color: "inherit" }} to="/service">
              ALLES WETTEN
            </Link>
          </p>
          <p>
            <Link style={{ color: "inherit" }} to="/regio">
              CONTACT
            </Link>
          </p>
          {/* <p>INVESTMENT</p> */}
        </div>
        <div className="col-12 col-sm-3 text-center normal-font">
          <p>
            <Link style={{ color: "inherit" }} to="/news">
              INVESTEREN
            </Link>
          </p>
          {/* <p>VIEW THE FILM</p> */}
        </div>
      </div>
      <div className="row justify-content-center">
        <div
          className="d-flex flex-column align-items-center"
          style={{ cursor: "pointer" }}
          onClick={() => window.scroll({ top: 0, behavior: "smooth" })}
        >
          <FaChevronUp size="30" style={{ transform: "scale(1.5,1)" }} />
          <div>terug naar top</div>
        </div>
      </div>
      <div className="row row-content m-auto">
        <div className="col col-sm-2 m-auto d-flex justify-content-center">
          <FaFacebookF size="35" />
          <FaInstagram size="35" />
          {/* <div className="col"></div>
                        <div className="col"> </div> */}
        </div>
      </div>
      {/* <div className="row">
            <div className="col m-auto text-center">
                    <p className="row-font text-center m-auto bulbuliti">Terms & Conditions</p>
                    <p className="row-font text-center m-auto">Privacy Policy</p>
                </div>
        </div> */}
      <div className="row">
        <div className="col-12 m-auto">
          <p className="text-center" style={{ fontWeight: "bold" }}>
            Urb. Cancella de la quinta Local 1/2 Marbella 29670 T. + 32 468 07
            51 68 + 34 633 31 84 62 info@vhenga.be Privacy Alg.voorwaarden
          </p>
        </div>
      </div>
    </div>
  );
}

export default Footer;
